export const AppState = {
  hasModalOpen: false,
  systemCart: {},
  cartContents: { items: [], count: 0 },
};
